import stateForPath from './stateForPath'
import * as stateHandlers from './stateHandlers'

export default stateForPath(stateHandlers)



// WEBPACK FOOTER //
// ./src/router/index.js